import React, { useState } from 'react'
import notetohostStyle from './notetohostInfo.module.css'
require('typeface-poppins')


export default function NotetohostInfo({ noteHost }) {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${notetohostStyle.contactAccordion} accordion mb-5`} id="ContactInfo">
                <div className={`${notetohostStyle.contactMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${notetohostStyle.contactbuttonItem} ${notetohostStyle.notehostBeforebg} accordion-button ${openIndex === 0 ? '' : `${notetohostStyle.notehostbgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            Note to Hosts
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ContactInfo">
                        <div className={`${notetohostStyle.moreBody} accordion-body`}>
                            <div className={notetohostStyle.infoWrapper}>
                                <p className='pb-2'>{noteHost}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}